import SseHub from './SseHub.js';

// Cliente SSE para la narración del análisis IA de documentos del item enriquecido.
// Singleton de módulo (patrón GeneracionItemsEvents): la conexión sobrevive a la
// navegación y se cierra al quedarse sin suscriptores (HTTP/1.1 local = ~6 conexiones/host).

const subscribers = [];
let enganchado = false;
const CANAL = 'item-documento';
let f7ref = null;

function notify(payload) {
    subscribers.slice().forEach(function (cb) {
        try { cb(payload); } catch (err) { console.error('ItemDocumentoEvents subscriber threw', err); }
    });
}

function toastGlobal(texto) {
    try {
        if (f7ref && f7ref.toast) {
            f7ref.toast.create({ text: texto, closeTimeout: 5000, closeButton: true }).open();
        }
    } catch (e) {}
}

function onEvento(evento) {
    // El hub entrega el payload ya deserializado (antes llegaba el evento SSE crudo). Se
    // admite tambien una cadena por si algun emisor mandara texto plano.
    let payload = evento;
    if (typeof evento === 'string') {
        try { payload = JSON.parse(evento); } catch (err) { payload = evento; }
    }
    // Timestamp para distinguir "llega en vivo" de "llega todo de golpe" (buffering del proxy).
    console.log('[ItemDocumentoEvents] frame SSE @', new Date().toISOString(), payload);
    if (payload && payload.estado === 'fin') {
        toastGlobal('✅ ' + (payload.texto || 'Análisis del documento terminado.'));
    } else if (payload && payload.estado === 'error') {
        toastGlobal('⚠️ ' + (payload.texto || 'Error analizando el documento.'));
    }
    notify(payload);
}

function ensureConnected() {
    if (enganchado) return;
    enganchado = true;
    // Ya no se abre una conexion propia: el hub trae TODOS los canales por un unico stream
    // (el navegador solo admite ~6 por origen en HTTP/1.1 y la app tiene 8 canales).
    SseHub.subscribe(CANAL, onEvento);
}

export default {
    subscribe(callback, f7) {
        if (f7) f7ref = f7;
        if (typeof callback === 'function' && subscribers.indexOf(callback) < 0) {
            subscribers.push(callback);
        }
        ensureConnected();
    },
    unsubscribe(callback) {
        const i = subscribers.indexOf(callback);
        if (i >= 0) subscribers.splice(i, 1);
        if (!subscribers.length) this.close();
    },
    close() {
        // La conexion es unica y compartida por todos los canales: aqui solo nos desenganchamos.
        if (enganchado) {
            SseHub.unsubscribe(CANAL, onEvento);
            enganchado = false;
        }
    }
};
